import { es } from '../strings/es.ts'
import { PORQUE } from './porQue.ts'

/**
 * El documento, dentro de la app.
 *
 * Está aquí y no en un enlace por dos motivos. Uno: la app se usa en modo avión
 * y un enlace no se abre. Dos: enseñárselo a la tutora no debería obligar a
 * compartir una dirección de internet.
 *
 * Se lee, no se toca: no hay un solo control en toda la pantalla salvo el de
 * volver. Es la única de la app que es un texto y nada más.
 */
export function PorQue({ onBack }: { onBack: () => void }) {
  return (
    <div className="mx-auto max-w-2xl px-5 pt-5 pb-16">
      <button type="button" onClick={onBack} className="text-muted mb-5 text-sm font-bold">
        {es.today.back}
      </button>

      <h1 className="mb-3 text-2xl font-extrabold tracking-tight">{PORQUE.titulo}</h1>
      <p className="text-muted mt-0 mb-8">{PORQUE.entradilla}</p>

      <section className="border-gold bg-gold-soft mb-8 rounded-xl border-t-4 p-5">
        <h2 className="text-gold m-0 mb-2 text-xs font-bold tracking-[0.1em] uppercase">
          {PORQUE.frase.titulo}
        </h2>
        <p className="m-0 mb-3 text-xl font-extrabold">{PORQUE.frase.texto}</p>
        <p className="m-0 text-sm">{PORQUE.frase.detalle}</p>
      </section>

      {PORQUE.nombres.map((bloque) => (
        <section key={bloque.titulo} className="mb-7">
          <h2 className="mb-2 text-lg font-extrabold">{bloque.titulo}</h2>
          {bloque.parrafos.map((parrafo) => (
            <p key={parrafo} className="mt-0 mb-3">
              {parrafo}
            </p>
          ))}
        </section>
      ))}

      <section className="mb-8">
        <h2 className="mb-1 text-lg font-extrabold">{PORQUE.decirle.titulo}</h2>
        <p className="text-muted mt-0 mb-3 text-sm">{PORQUE.decirle.ayuda}</p>
        <ul className="grid list-none gap-3 p-0">
          {PORQUE.decirle.filas.map((fila) => (
            <li key={fila.quien} className="border-rule bg-surface m-0 rounded-xl border p-4">
              <p className="m-0 mb-2 font-extrabold">{fila.quien}</p>
              <p className="border-mint m-0 mb-2 border-l-4 pl-3">{fila.decir}</p>
              <p className="border-coral text-muted m-0 border-l-4 pl-3 text-sm">{fila.evitar}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className="mb-7">
        <h2 className="mb-2 text-lg font-extrabold">{PORQUE.senal.titulo}</h2>
        {PORQUE.senal.parrafos.map((parrafo) => (
          <p key={parrafo} className="mt-0 mb-3">
            {parrafo}
          </p>
        ))}
      </section>

      <section className="mb-7">
        <h2 className="mb-2 text-lg font-extrabold">{PORQUE.mates.titulo}</h2>
        {PORQUE.mates.parrafos.map((parrafo) => (
          <p key={parrafo} className="mt-0 mb-3">
            {parrafo}
          </p>
        ))}
      </section>

      <section className="border-coral bg-coral-soft rounded-xl border-t-4 p-5">
        <h2 className="text-coral m-0 mb-2 text-xs font-bold tracking-[0.1em] uppercase">
          {PORQUE.aviso.titulo}
        </h2>
        {PORQUE.aviso.parrafos.map((parrafo) => (
          <p key={parrafo} className="mt-0 mb-3 text-sm">
            {parrafo}
          </p>
        ))}
        <ul className="m-0 grid list-none gap-2 p-0">
          {PORQUE.aviso.reglas.map((regla) => (
            <li key={regla} className="m-0 text-sm font-bold">
              {regla}
            </li>
          ))}
        </ul>
      </section>
    </div>
  )
}
